import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import React, {useState} from "react";
import Stack from "react-bootstrap/Stack";

export interface VariationEntry {
    id: string,
    name: string
}

interface SquareVariationSelectorProps {
    variations: VariationEntry[],
    notifySelectedVariations: (updatedVariations: VariationEntry[]) => void
}

const MAX_SQUARE_ENTRIES : number = 4;
const DEFAULT_DROPDOWN_VALUE : string = "default";

export default function SquareVariationSelector(props: SquareVariationSelectorProps) {

    const [selectedEntries, setSelectedEntries] = useState<VariationEntry[]>([]);
    const [dropValue, setDropValue] = useState<string>(DEFAULT_DROPDOWN_VALUE);

    const addItem = (id: string) => {
        const item = props.variations.find(variation => variation.id === id);
        if (item === undefined || selectedEntries.includes(item)) {
            return;
        }
        selectedEntries.push(item);
        setSelectedEntries([...selectedEntries]);
        props.notifySelectedVariations(selectedEntries);
    }

    const removeItem = (id: string) => {
        const idx = selectedEntries.findIndex(variation => variation.id === id);
        if (idx < 0) {
            return;
        }
        selectedEntries.splice(idx, 1);
        setSelectedEntries([...selectedEntries]);
        props.notifySelectedVariations(selectedEntries);
    };

    const buttons = (
        <Stack direction="horizontal" gap={1}>
        {selectedEntries.map((item) => <Button key={item.id} onClick={() => removeItem(item.id)}>{item.name}</Button>)}
        </Stack>);

    return (
        <Stack gap={2}>
            <Form.Select aria-label="Square variations" value={dropValue} disabled={selectedEntries.length >= MAX_SQUARE_ENTRIES}
                         onChange={(evt) => {
                             addItem(evt.target.value);
                             setDropValue(DEFAULT_DROPDOWN_VALUE);
                         }
            }>
                <option key={"default"}>{`Select up to ${MAX_SQUARE_ENTRIES} items`}</option>
                {props.variations.map(v => <option key={v.id} value={v.id}>{v.name}</option>)}
            </Form.Select>
            {buttons}
        </Stack>
    );
}